import { forwardRef } from 'react';

import { Box, Paper, Stack, styled } from '@mui/material';
import { cn } from '@natter-co/design-system';
import { useInheritedVisualRefresh } from 'common/theme';

import type { PaperProps } from '@mui/material';

const LegacyFormWrapper = styled(Paper)(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: spacing(3),
  gap: spacing(3),
}));

export const FormWrapper = forwardRef<HTMLDivElement, PaperProps>(({ className, ...props }, ref) => {
  const visualRefresh = useInheritedVisualRefresh();

  const canUseContainer =
    props.elevation === undefined &&
    props.variant === undefined &&
    props.square === undefined &&
    props.classes === undefined;

  return visualRefresh && canUseContainer ? (
    <Box
      ref={ref}
      className={cn(
        'rounded-md border border-[var(--border-primary)] bg-[var(--background-primary)] p-4 flex flex-col gap-6',
        className
      )}
      {...props}
    />
  ) : (
    <LegacyFormWrapper ref={ref} className={className} {...props} />
  );
});

export const FormSectionWrapper = styled(Stack)(({ theme: { spacing } }) => ({
  gap: spacing(2),
}));
